export enum LoanApplicationCategory {
  MORTGAGE = 1,
  CASH = 2,
  SME = 4,
}
